import React from 'react';
import { Reveal } from './Reveal';
import { GlassWhatsApp } from './ContactButtons';
export function Testimonials() {
  return <section className="relative w-full bg-ink py-16 sm:py-24" data-id="element-174" data-mp="3krp5n656qzqv">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" data-id="element-175" data-mp="3fz5nrwzgtig9" />
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-176" data-mp="3azjcht376ca3">
        <Reveal data-id="element-177" data-mp="36yzeyoepp6nf">
          <h2 className="font-serif text-4xl leading-tight text-gold-light sm:text-5xl" data-id="element-178" data-mp="36zilza2tqamo">
            ¡Lo que dicen de nosotros!
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-179" data-mp="321z9ofpos7xd">
          <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-white/65" data-id="element-180" data-mp="2x0jmoi3y7rcc">
            Historias reales de personas que confiaron su proceso amoroso a nuestros maestros.
          </p>
        </Reveal>

        <Reveal delay={0.18} data-id="element-181" data-mp="v9oqhp5txq53">
          <div className="mx-auto mt-12 w-full max-w-sm overflow-hidden rounded-[1.75rem] border border-white/10 bg-black shadow-[0_50px_120px_-50px_rgba(0,0,0,0.95)]" data-id="element-182" data-mp="v8wvafg59ufc">
            <video src="https://cdn.magicpatterns.com/uploads/xiuyfbnn27Ce9xdUaMpTFV/WhatsApp%20Video%202024-04-25%20at%2012.56.43%20PM.mp4" controls playsInline preload="metadata" className="block max-h-[70vh] w-full bg-black object-contain" data-id="element-183" data-mp="h4wva3k7seiq">
              Tu navegador no admite la reproducción de video.
            </video>
          </div>
        </Reveal>

        <Reveal delay={0.26} data-id="element-184" data-mp="zyiwvitgiu13">
          <div className="mt-10 flex justify-center" data-id="element-185" data-mp="14v9b00lpbfjv">
            <GlassWhatsApp data-id="element-186" data-mp="14ur7ciwplz1x">Escribir vía WhatsApp</GlassWhatsApp>
          </div>
        </Reveal>
      </div>
    </section>;
}